import React from 'react';
import { useSelector } from 'react-redux';

import closeIcon from '../../asset/img/common/close_icon.svg';

import { MessageStyled } from '../../asset/styled/component/MessageStyled';
import Button from './Button';

const Message = ({
  clickCancelBtn,
  title = '확인해주세요!',
  contents = (
    <>
      입력한 내용이 저장되지 않았습니다.
      <br />
      저장하지 않고 나가시겠습니까?
    </>
  ),
  onClick,
  btn02Name = '나가기',
}) => {
  return (
    <div className="modalOverlay" style={{ zIndex: '2000' }}>
      <MessageStyled>
        <img src={closeIcon} alt="" className="closeImg" onClick={() => clickCancelBtn()} />
        <div className="subtitleBold">{title}</div>
        <div className="body2Medium" style={{ padding: '10px 0px' }}>
          {contents}
        </div>
        <div className="displayFlex" style={{ gap: '24px', marginTop: '20px' }}>
          <Button
            color="modalgray"
            size="large"
            variant="outline"
            onClick={() => clickCancelBtn()}
            value="취소"
          />
          <Button size="large" onClick={onClick} value={btn02Name} />
        </div>
      </MessageStyled>
    </div>
  );
};

export default Message;

export const ConfirmMessage = ({ onConfirm, title = '확인해주세요.', contents = '' }) => {
  return (
    <div className="modalOverlay" style={{ zIndex: '2000' }}>
      <MessageStyled>
        <img src={closeIcon} alt="" className="closeImg" onClick={() => onConfirm()} />
        <div className="subtitleBold">{title}</div>
        <div
          className="body2Medium noneScroll"
          style={{ padding: '10px 0px', height: '300px', overflow: 'scroll' }}>
          {typeof contents === 'string'
            ? contents.split('\n').map((line, index) => (
                <React.Fragment key={index}>
                  {line}
                  {index < contents.split('\n').length - 1 && <br />}
                </React.Fragment>
              ))
            : contents}
        </div>
        <div className="displayFlex" style={{ justifyContent: 'center', marginTop: '20px' }}>
          <Button size="large" onClick={() => onConfirm()} value="확인" />
        </div>
      </MessageStyled>
    </div>
  );
};

export const CustomMessage = ({ closeMsg }) => {
  const { title, contents, btn01Name, btn02Name, onConfirm } = useSelector(
    state => state.customMsg,
  );

  return (
    <div className="modalOverlay" style={{ zIndex: '2000' }}>
      <MessageStyled>
        <img src={closeIcon} alt="" className="closeImg" onClick={closeMsg} />
        <div className="subtitleBold">{title}</div>
        <div className="body2Medium" style={{ marginTop: '10px' }}>
          {contents}
        </div>
        <div className="displayFlex" style={{ gap: '24px', marginTop: '20px' }}>
          <Button
            color="modalgray"
            size="large"
            variant="outline"
            onClick={closeMsg}
            value={btn01Name}
          />
          <Button
            size="large"
            onClick={() => {
              onConfirm();
              closeMsg();
            }}
            value={btn02Name}
          />
        </div>
      </MessageStyled>
    </div>
  );
};
